import { ComponentProps, ReactElement } from 'react';

import InvoiceDetail from '@/features/PdfLayout/layouts/Invoice/InvoicePdfDetail';

export type InvoiceAddressProps = ComponentProps<typeof InvoiceDetail> & {
  address?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | number | null;
  country?: string | null;
};

const InvoiceAddress = ({ address, city, state, zip, country, ...props }: InvoiceAddressProps): ReactElement => {
  address = address?.trim() || '';
  city = city?.trim() || '';
  state = state?.trim() || '';
  zip = zip ? `${zip}`.trim() : '';
  country = country?.trim() || '';

  const postalInfo = [`${city}${state || zip ? ',' : ''}`, state, zip]
    .filter((val: string): boolean => !!`${val || ''}`.replace(',', ''))
    .join(' ');

  return (
    <>
      {address && <InvoiceDetail {...props}>{address}</InvoiceDetail>}
      {postalInfo && <InvoiceDetail {...props}>{postalInfo}</InvoiceDetail>}
      {country && <InvoiceDetail {...props}>{country}</InvoiceDetail>}
    </>
  );
};

export default InvoiceAddress;
